<script setup lang="ts">
import { useEventStore } from '@/stores/useEventStore'
import { storeToRefs } from 'pinia'
import { dateComparator } from '@/utils/dateUtils'
import GridVue from '@/components/data-visualization/grids/GridVue.vue'
import EventCalendar from '@/components/features/events/EventCalendar.vue'

const eventStore = useEventStore()
const { eventsPartnerList } = storeToRefs(eventStore)
</script>

<template>
  <div class="mb-4">
    <GridVue
      context="events"
      :list="eventsPartnerList"
      :cols="[
        { field: 'name', headerName: 'Sujet', flex: 3 },
        {
          field: 'start',
          headerName: 'Date',
          filter: 'agDateColumnFilter',
          flex: 2,
          comparator: dateComparator,
        },
        { field: 'category', headerName: 'Catégorie' },
        { field: 'author', headerName: 'Auteur' },
      ]"
      :paginationPageSize="5"
    />
  </div>
  <EventCalendar :show-filter-commercial="false" :partner-only="true" />
</template>
